import * as React from "react";
import './RNTagItem.css';

export class RNTagItem extends React.Component<RNTagItemProps, RNTagItemState> {
    static defaultProps: Partial<RNTagItemProps> = {};

    constructor(props: RNTagItemProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <li className={'rnTagItem'} style={{cursor:"pointer",padding:15,border:'1px solid #dfdfdf',margin:0,marginBottom:-1}} onClick={()=>this.props.onClick&&this.props.onClick()}>{this.props.Label}</li>
        )
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface RNTagItemProps {
    Label:string;
    Value:any;
    Type:any;
    onClick:()=>void;
}

interface RNTagItemState {

}

//#endregion "My Region"